// extracted by mini-css-extract-plugin
export default {"input-group":"InputGroup_input-group__Bcl-o","label":"InputGroup_label__JULsn","input-group-text":"InputGroup_input-group-text__rBqhj"};